import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const FooterEditor = () => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/all`);
      const data = await response.json();
      if (data.success) {
        setContent(data.data.footer || {});
      }
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/content/footer`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(content)
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ التذييل بنجاح!');
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'خطأ في حفظ المحتوى');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>محرر التذييل</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-grid">
        <div className="editor-column">
          <h3>المحتوى العربي</h3>
          <div className="editor-form-group">
            <label>عنوان النشرة الإخبارية</label>
            <textarea
              rows="2"
              value={content.newsletter_title_ar || ''}
              onChange={(e) => setContent({...content, newsletter_title_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>نص حقوق النشر</label>
            <input
              type="text"
              value={content.copyright_ar || ''}
              onChange={(e) => setContent({...content, copyright_ar: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>وصف الشركة</label>
            <textarea
              rows="4"
              value={content.company_description_ar || ''}
              onChange={(e) => setContent({...content, company_description_ar: e.target.value})}
            />
          </div>
        </div>

        <div className="editor-column">
          <h3>المحتوى الإنجليزي</h3>
          <div className="editor-form-group">
            <label>Newsletter Title (English)</label>
            <textarea
              rows="2"
              value={content.newsletter_title_en || ''}
              onChange={(e) => setContent({...content, newsletter_title_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Copyright (English)</label>
            <input
              type="text"
              value={content.copyright_en || ''}
              onChange={(e) => setContent({...content, copyright_en: e.target.value})}
            />
          </div>
          <div className="editor-form-group">
            <label>Company Description (English)</label>
            <textarea
              rows="4"
              value={content.company_description_en || ''}
              onChange={(e) => setContent({...content, company_description_en: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="editor-form-group">
        <label>اسم الشركة</label>
        <input
          type="text"
          value={content.company_name || ''}
          onChange={(e) => setContent({...content, company_name: e.target.value})}
        />
      </div>

      <div className="editor-actions">
        <button className="editor-btn-save" onClick={handleSave} disabled={saving}>
          {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
        </button>
      </div>
    </div>
  );
};

export default FooterEditor;

